import alert from '@components/alert';
import { LOGIN_ERROR } from '@model';
import { clearTokens } from '@utils/common';

let retryTimes = 1;
const handleJWTSyntaxError = (socket) => {
  console.log(
    `Missing valid token, try to reconnect, retry times: ${retryTimes}`,
  );
  if (retryTimes <= 5) {
    const token =
      window.localStorage.getItem('accessToken') ||
      window.localStorage.getItem('accessToken');
    if (token) {
      socket.auth.token = token;
      socket.connect();
      retryTimes = 1;
    } else {
      retryTimes += 1;
      setTimeout(handleJWTSyntaxError, 3000, socket);
    }
  }
};

const handleTokenExpire = () => {
  alert.error({
    content: LOGIN_ERROR.SESSION_TIMEOUT,
    onOk: () => {
      clearTokens();
      window.location.pathname = '/';
    },
  });
};

export const handleSocketError = (socket, error) => {
  const errorMsg = error.message || error.toString();
  switch (errorMsg) {
    case 'incorrect JWT syntax':
      handleJWTSyntaxError(socket, error);
      break;
    case 'token expired':
      handleTokenExpire(socket, error);
      break;
    default: {
      console.log(`No correspond error handler for: ${errorMsg}`);
    }
  }
};
